var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4614_150913)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#ECF3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0032 13.9983C12.7946 13.9983 13.5682 13.7636 14.2261 13.324C14.8841 12.8843 15.3969 12.2594 15.6998 11.5283C16.0026 10.7972 16.0818 9.99275 15.9275 9.21661C15.7731 8.44048 15.392 7.72755 14.8324 7.16799C14.2729 6.60842 13.56 6.22736 12.7838 6.07298C12.0077 5.91859 11.2032 5.99783 10.4721 6.30066C9.74099 6.60349 9.11611 7.11632 8.67646 7.7743C8.23682 8.43227 8.00216 9.20584 8.00216 9.99718C8.00216 11.0583 8.4237 12.076 9.17405 12.8264C9.9244 13.5767 10.9421 13.9983 12.0032 13.9983Z",
    fill: "#1271A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0032 15.9988C10.1462 15.9988 8.36526 16.7365 7.05215 18.0496C5.73904 19.3627 5.00134 21.1437 5.00134 23.0007C5.00134 23.266 5.10673 23.5204 5.29432 23.708C5.4819 23.8956 5.73633 24.001 6.00161 24.001H18.0049C18.2702 24.001 18.5246 23.8956 18.7122 23.708C18.8998 23.5204 19.0052 23.266 19.0052 23.0007C19.0052 21.1437 18.2675 19.3627 16.9543 18.0496C15.6412 16.7365 13.8603 15.9988 12.0032 15.9988Z",
    fill: "#1271A6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4614_150913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.f93dae5279f1a9c73b93d70a26aeffdf.svg";
export { ForwardRef as ReactComponent };